export default "__VITE_ASSET__Ad7JCBAd__"